<template>
    <v-list
            one-line
            class="pa-0"
    >
        <v-list-group value="true">
            <v-list-tile slot="item">
                <v-list-tile-content>
                    <v-list-tile-title>Boost your profile</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                    <v-icon>keyboard_arrow_down</v-icon>
                </v-list-tile-action>
            </v-list-tile>
            <v-list-tile
                    avatar
                    ripple
                    v-for="provider in limitedProviderList"
                    :key="provider.Code"
                    @click="linkProfile(provider.Code)"
            >
                <v-list-tile-avatar>
                    <v-icon
                            :class="[provider.Code]"
                    >
                        fa-{{provider.Code}}
                    </v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                    <v-list-tile-title v-text="provider.Name"></v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                    <v-list-tile-action-text>
                        <div :class="statusClass(provider.Code)">{{ status(provider.Code) }}</div>
                    </v-list-tile-action-text>
                </v-list-tile-action>
            </v-list-tile>
        </v-list-group>
    </v-list>
</template>

<script>
    import { mapGetters } from 'vuex';
    import userReadable from '@/utils/time';

    export default {
        name: 'me-profile-connections',
        data() {
            return {};
        },
        computed: {
            ...mapGetters('profileProviders', [
                'limitedProviderList',
            ]),
            ...mapGetters('profile', [
                'profileConnections',
            ]),
        },
        methods: {
            statusClass(providerCode) {
                const connection = this.profileConnection(providerCode);
                if (connection && connection.RequiresReauthentication) {
                    return 'status important';
                }

                return 'status';
            },
            status(providerCode) {
                const connection = this.profileConnection(providerCode);
                if (!connection) {
                    return 'not connected';
                }

                if (connection.RequiresReauthentication) {
                    return 'requires reauthentication';
                }

                if (connection.AccessTokenExpiration) {
                    if (connection.AccessTokenExpiration === '0001-01-01T00:00:00Z') {
                        return 'never expires';
                    }

                    return `expires on ${userReadable(connection.AccessTokenExpiration)}`;
                }

                return 'connected';
            },
            profileConnection(providerCode) {
                for (let i = 0; i < this.profileConnections.length; i += 1) {
                    const connection = this.profileConnections[i];
                    if (connection.ProfileProviderId === providerCode) {
                        return connection;
                    }
                }

                return undefined;
            },
            linkProfile(providerCode) {
                const provider
                    = this.limitedProviderList.find(element => element.Code === providerCode);

                if (provider) {
                    this.$store.dispatch('profile/AUTHORIZE_PROFILE_CONNECTION', provider);
                } else {
                    const error = new Error(`Provider with code ${providerCode} was not found in limited list of profile providers!`);
                    this.$store.dispatch('errors/ADD', error);
                }
            },
        },
        created() {
            this.$store.dispatch('profile/LIST_PROFILE_CONNECTIONS');
            this.$store.dispatch('profileProviders/LIST_ALL');
        },
    };
</script>

<style lang="stylus" scoped>
    .status.important
        color red !important

    .avatar
        .icon.facebook
            color white
            background-color #3B5998

        .icon.spotify
            color #6AE368
            background-color white
            font-size 3.3rem
</style>



// WEBPACK FOOTER //
// ProfileConnections.vue?422f6385